(function () {
  const REF_KEY = 'sibrape_ref';
  const RESELLER_ATTR = '_reseller';
  const ATTRIBUTION_ID = 'sibrape-cart-attribution';

  // Alinhado com checkout_button_selectors do app Sibrape (templates/cart.json)
  const CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    '.cart__checkout-button',
    'a[href="/checkout"]'
  ].join(', ');

  const OBSERVED_ATTRS = ['disabled', 'style', 'class', 'aria-disabled', 'hidden'];

  let bypassActive = null;
  let observer = null;
  let rafId = null;

  function isValidResellerRef(ref) {
    return Boolean(ref) && ref.toLowerCase().includes('revenda');
  }

  function getRefFromUrl() {
    return new URLSearchParams(window.location.search).get('ref');
  }

  function getPersistedRef() {
    const urlRef = getRefFromUrl();
    if (urlRef !== null) {
      return isValidResellerRef(urlRef) ? urlRef : null;
    }

    const storedRef = sessionStorage.getItem(REF_KEY);
    return isValidResellerRef(storedRef) ? storedRef : null;
  }

  function persistRef(ref) {
    if (isValidResellerRef(ref)) {
      sessionStorage.setItem(REF_KEY, ref);
    } else {
      sessionStorage.removeItem(REF_KEY);
    }
  }

  function isBypassActive() {
    if (bypassActive !== null) return bypassActive;
    bypassActive = window.sibrapeReseller?.isReseller === true || getPersistedRef() !== null;
    return bypassActive;
  }

  function getCheckoutButtons() {
    return document.querySelectorAll(CHECKOUT_SELECTOR);
  }

  function isEmptyCartDrawer(button) {
    const drawerContent = button.closest('cart-drawer')?.querySelector('.cart-drawer__content');
    return drawerContent?.classList.contains('grow') ?? false;
  }

  async function setResellerCartAttribute() {
    if (!getPersistedRef() || window.sibrapeReseller?.isReseller === true) return;

    const cartUpdateUrl = window.theme?.routes?.cartUpdate || '/cart/update.js';

    try {
      const response = await fetch(cartUpdateUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: { [RESELLER_ATTR]: 'true' }
        })
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      if (window.sibrapeReseller) {
        window.sibrapeReseller.isReseller = true;
      }
      bypassActive = true;
    } catch (error) {
      console.error('Sibrape: erro ao definir atributo _reseller no carrinho', error);
    }
  }

  function hideAttributionBlock() {
    const attribution = document.getElementById(ATTRIBUTION_ID);
    if (!attribution || attribution.hidden) return;

    attribution.hidden = true;
    attribution.style.display = 'none';

    const wrapper = attribution.closest('.inline-block');
    if (wrapper) wrapper.hidden = true;
  }

  function hideCheckoutEnabledMessage() {
    const enabledMessage = document.getElementById('cart-checkout-enabled-message');
    if (enabledMessage) enabledMessage.hidden = true;
  }

  function enableCheckoutButton(button) {
    if (isEmptyCartDrawer(button)) return;

    button.disabled = false;
    button.removeAttribute('aria-disabled');
    button.style.removeProperty('pointer-events');
    button.style.removeProperty('opacity');
    button.classList.remove('disabled');
  }

  function enableCheckoutButtons() {
    getCheckoutButtons().forEach(enableCheckoutButton);
  }

  function applyResellerBypass() {
    hideAttributionBlock();
    hideCheckoutEnabledMessage();
    enableCheckoutButtons();
  }

  function scheduleBypass() {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      applyResellerBypass();
    });
  }

  function getBypassRoot() {
    return (
      document.getElementById('cart') ||
      document.getElementById('cart-summary-and-blocks') ||
      document.getElementById(ATTRIBUTION_ID)
    );
  }

  function startBypassObserver() {
    if (observer) return;

    const root = getBypassRoot();
    if (!root) return;

    applyResellerBypass();

    observer = new MutationObserver(scheduleBypass);
    observer.observe(root, {
      attributes: true,
      subtree: true,
      attributeFilter: OBSERVED_ATTRS
    });
  }

  function initCheckoutBypass() {
    if (!isBypassActive() || !getBypassRoot()) return;
    startBypassObserver();
  }

  function init() {
    const refFromUrl = getRefFromUrl();
    if (refFromUrl !== null) persistRef(refFromUrl);

    if (!isBypassActive()) return;

    setResellerCartAttribute();
    initCheckoutBypass();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
